import React, { useEffect, useState } from "react";
import {
  BannerCompanyCard,
  Tabs,
} from "../../../components/public/Company/Profile";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useGetCompanyNewQuery } from "../../../store/search/searchApiSlice";
import { LoadingIcon, Modal, SessionExpired } from "../../../components/common";
import Breadcrumb from "../../../components/public/Breadcrumbs";
import { clearUserInfo } from '../../../store/auth/authSlice'
import {
  useGetBPCompanyQuery,
  useGetCompanyPurchaseDetailsMutation,
  useGetOptimisedCompanyDetailsQuery,
  useGetCompanyQuery,
  useGetIndividualQuery,
  useGetIndividualPromptQuery,
} from "../../../store/Company/companyApiSlice";
import { NotFoundCompany } from "../NotFoundCompany";
import { formatDateToISO } from "../../../utils/Helper";
import { useMemo } from "react";
import { isAfter, isEqual } from "date-fns";
import GptPrompt from "../../../components/public/Home/GptPrompt";

export const CompanyProfile = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isPrompt = location.pathname.includes("prompt")
  const [company, setCompanyData] = useState();
  const [trevexId, setTrevexId] = useState(false);
  const [notTrevexId, setNotTrevexId] = useState(false);
  const [isPurchased, setIsPurchased] = useState("");
  const [isClaimed, setIsClaimed] = useState(false);
  const { worldBoxToken } = useSelector((state) => state.search);
  const { token, userInfo } = useSelector((state) => state.auth);
  const [selectedEnterprise, setSelectedEnterprise] = useState();
  const [isContinue, setIsContinue] = useState(false);
  const [userEnterprise, setUserEnterprise] = useState([]);
  const [purchaseSubScriptionValid, setPurchaseSubScriptionValid] = useState(false)
  const [creditNoticePopup, setCreditNoticePopup] = useState(false);
  const { id } = useParams();
  const currentURL = window.location.href;
  const parts = currentURL.split("/");
  const currentCompanyId = parts[parts.length - 1];
  const [getPurchaseDetailsStatus] = useGetCompanyPurchaseDetailsMutation();
  const [isSessionExpired, setSessionExpired] = useState(false);
  const [isGetTheCompanyOpen, setIsGetTheCompanyOpen] = useState(false);
  const handleGetCompanyPopup = () => {
    setIsGetTheCompanyOpen(!isGetTheCompanyOpen);
  };
  const [formData, setFormData] = useState({
    name: '',
    designation: '',
    email: '',
    contactNumber: '',
  });
  const sessionExpiredPopup = () => {
    setSessionExpired(!isSessionExpired);
    dispatch(clearUserInfo());
    navigate("/login");
  };
  const promptCrumbs = [{ label: "Home", url: "/gpt-prompts/access" }, { label: "Search Result", url: "/gpt-prompts/search" }, { label: "Prompt Details", url: `/gpt-prompts/search/${id}` }];
  const [getDetailsClicked, setGetDetailsClicked] = useState(false)
  const [userIndividualData, setUserIndividualData] = useState();
  const [subscriptionActiveData, setSubscriptionActiveData] = useState()
  const userIndividualCompany = userInfo?.individual[0]?.individual || [];
  const companyInfo = userIndividualCompany.find(company => company?.companyID?.companyID === id);
  const role = companyInfo ? companyInfo.role : undefined;
  const userIndividual = userInfo?.individual[0]?.individualID;
  const { data: individualData, refetch } = useGetIndividualQuery({
    individualID: userIndividual,
    token,
  }, { skip: isPrompt });
  const { data: individualPromptData, refetch: refetchPrompt } = useGetIndividualPromptQuery({
    promptID: id,
    token,
  }, { skip: !isPrompt });

  useEffect(() => {
    setUserIndividualData(isPrompt ? individualPromptData : individualData);
  }, [individualData, individualPromptData]);

  useEffect(() => {
    const todaysDate = new Date();
    const SubscriptionActive = userIndividualData?.individualSubscription?.find(
      (sub) => sub?.status === "active" && sub?.subscription_type !== "pay-as-you-go" && (isAfter(new Date(sub.date_of_end), todaysDate) || isEqual(new Date(sub.date_of_end), todaysDate))
    );
    setSubscriptionActiveData(SubscriptionActive);
  }, [userIndividualData]);

  useEffect(() => {
    if (id) {
      let value = id.includes("TRX");
      if (value) {
        setTrevexId(value);
      } else {
        setNotTrevexId(!value);
      }
    }
  }, [id]);

  useEffect(() => {
    const isMatching = userInfo?.individual[0]?.requestIndividual?.find(
      (i) => i?.companyID?.companyID === id
    );
    if (isMatching?.companyID?.companyID === id) setIsClaimed(true);
  }, [id, userInfo?.individual]);

  useEffect(() => {
    (async () => {
      const res = await getPurchaseDetailsStatus({
        companyID: id,
        userID: userInfo?.individual[0]?.userID,
        token: token
      });

      let purchaseData = ""
      if (res?.data?.enterprise?.purchaseID) {
        purchaseData = {
          purchaseID: res?.data?.enterprise?.purchaseID,
          companyID: res?.data?.enterprise?.companyID,
          planID: res?.data?.enterprise?.planID,
          purchaseDate: res?.data?.enterprise?.purchaseDate,
          expireDate: res?.data?.enterprise?.expireDate,
          purchaseType: res?.data?.enterprise?.purchaseType,
          wb_id: res?.data?.enterprise?.wb_id,
          userID: res?.data?.enterprise?.userID,
        }
      } else {
        purchaseData = res?.data?.purchase
      }


      setIsPurchased(purchaseData);
    })();
  }, [id, userInfo?.individual]);

  useEffect(() => {
    const todayDate = formatDateToISO(new Date());
    const currentDate = new Date(todayDate);
    const purchaseSubScriptionStartDateStr = isPurchased?.purchaseDate;
    const purchaseSubScriptionEndDateStr = isPurchased?.expireDate;
    const purchaseSubScriptionStartDate = new Date(
      purchaseSubScriptionStartDateStr
    );
    const purchaseSubScriptionEndDate = new Date(purchaseSubScriptionEndDateStr);

    const purchaseSubScriptionValidCheck =
      currentDate >= purchaseSubScriptionStartDate &&
      currentDate <= purchaseSubScriptionEndDate;
    setPurchaseSubScriptionValid(purchaseSubScriptionValidCheck);
  }, [isPurchased])


  const {
    data: trevexData,
    isLoading: trevexDataLoading,
    isSuccess: gotTrevexData,
    isError, error,
  } = useGetOptimisedCompanyDetailsQuery(
    {
      isClaimed: isClaimed,
      role: role,
      purchaseSubScriptionValid: purchaseSubScriptionValid,
      companyId: id,
      token,
    },
    { skip: !trevexId }
  );

  const { data, isLoading, isSuccess } = useGetCompanyNewQuery(
    { id, worldBoxToken },
    { skip: !notTrevexId }
  );

  useEffect(() => {
    if (gotTrevexData) {
      setCompanyData(trevexData);
    }
    if (isSuccess) {
      setCompanyData(data);
    }
    if (isError) {
      if (error?.data?.code == 'token_not_valid') {
        setSessionExpired(true);
      }
    }
  }, [gotTrevexData, isSuccess, isError, isClaimed]);

  useMemo(() => {
    const filteredEnterpriseForCredit = userInfo?.enterprise_solutions?.filter((enterprise) => (enterprise?.credits !== undefined && enterprise?.credits !== null && enterprise?.credits > 0) || enterprise?.enterprise_type === "PARTNER_PROGRAM");
    setUserEnterprise(filteredEnterpriseForCredit)
  }, [userInfo])

  const secondayListedHandler = () => {
    let customerreference;
    if (!formData.name.trim()) {
      customerreference = 'No reference data provided';
    } else {
      customerreference = `Name: ${formData.name},
Designation: ${formData.designation},
Email: ${formData.email},
Contact: ${formData.contactNumber || 'N/A'},`;
    }
    let status =
      company?.companyID === undefined
        ? "listing"
        : company?.verifiedCompany != null
          ? "verified"
          : (company?.claimed && "claimed") || (company?.draft && "warning");
    let postData = {};
    let win_no;
    if (status === "listing") {
      win_no = company?.company.win;
      postData = {
        win_number: win_no,
        companyID: id,
        userID: userInfo?.individual[0]?.userID,
        customerreference: customerreference
      };
    } else if (status === "warning") {
      win_no = company?.wb_win;
      if (win_no == null) {
        if (company?.companyAddress?.length <= 0) {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1: company?.country_code,
            city: company?.country_code,
            countrycode: company?.country_code,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference
          };
        } else {
          postData = {
            companyID: id,
            companyname: company?.registered_company_name,
            address1:
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_1 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID
                ?.address_line_2 +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.area +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.city +
              " " +
              company?.companyAddress[0]?.company_address_detailsID?.state,
            city: company?.companyAddress[0]?.company_address_detailsID?.state,
            countrycode:
              company?.companyAddress[0]?.company_address_detailsID?.country,
            currency: "USD",
            userID: userInfo?.individual[0]?.userID,
            customerreference: customerreference,
          };
        }
      } else {
        postData = {
          win_number: win_no,
          companyID: id,
          userID: userInfo?.individual[0]?.userID,
          customerreference: customerreference
        };
      }
    }

    if (status === "listing" || status === "warning") {
      setIsContinue(true)
      localStorage.setItem("createWorldbox", true);
      localStorage.setItem("worldboxData", JSON.stringify(postData));
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
      handleGetCompanyPopup();
    } else {
      setIsContinue(true)
      localStorage.removeItem("UpgradePlan");
      const jsonData = JSON.stringify(currentCompanyId);
      localStorage.setItem("payasyougoCompanyID", jsonData);
    }
    handleGetCompanyPopup();
    setIsContinue(false)
    if (token) {
      window.scrollTo(0, 0);
      if (subscriptionActiveData?.no_of_profile_views >= 1 || userEnterprise?.length > 0) {
        setCreditNoticePopup(true);
      } else {
        return navigate("/plans", {
          state: { company_id: id },
        })
      };
    } else if (!token) {
      window.scrollTo(0, 0);
      if (subscriptionActiveData?.no_of_profile_views >= 1 || userEnterprise?.length > 0) {
        return navigate("/login?guest=true", {
          next: `/search/${id}`,
        });
      } else {
        return navigate("/login?guest=true", {
          next: "/plans",
          state: { company_id: id },
        });
      }
    }
  }

  return (
    <>
      <div className="mx-auto max-w-4 sm:px-4 px-0 pb-6 lg:px-8 bg-slate w-full">
        <Breadcrumb skipPath={isPrompt && promptCrumbs} />
        {isSessionExpired && <Modal modalHandle={sessionExpiredPopup}>
          <SessionExpired handleNavigate={sessionExpiredPopup} />
        </Modal>}

        {isLoading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <LoadingIcon />
          </div>
        )}
        {!isPrompt ? company && (
          <div className="max-w-7xl mx-auto">
            <BannerCompanyCard company={company} trevexId={trevexId} getDetailsClicked={getDetailsClicked} setGetDetailsClicked={setGetDetailsClicked} selectedEnterprise={selectedEnterprise} setSelectedEnterprise={setSelectedEnterprise} userEnterprise={userEnterprise} secondayListedHandler={secondayListedHandler} formData={formData} setFormData={setFormData} individualData={userIndividualData} refetch={refetch} creditNoticePopup={creditNoticePopup} setCreditNoticePopup={setCreditNoticePopup} setIsContinue={setIsContinue} isContinue={isContinue} SubscriptionActive={subscriptionActiveData} handleGetCompanyPopup={handleGetCompanyPopup} isGetTheCompanyOpen={isGetTheCompanyOpen} />
            <Tabs company={company} trevexId={trevexId} purchaseSubScriptionValid={purchaseSubScriptionValid} role={role} getDetailsClicked={getDetailsClicked}
              setGetDetailsClicked={setGetDetailsClicked} selectedEnterprise={selectedEnterprise} setSelectedEnterprise={setSelectedEnterprise} userEnterprise={userEnterprise} secondayListedHandler={secondayListedHandler} formData={formData} setFormData={setFormData} individualData={userIndividualData} refetch={refetch} creditNoticePopup={creditNoticePopup} setCreditNoticePopup={setCreditNoticePopup} setIsContinue={setIsContinue} isContinue={isContinue} SubscriptionActive={subscriptionActiveData} handleGetCompanyPopup={handleGetCompanyPopup} isGetTheCompanyOpen={isGetTheCompanyOpen} />
          </div>
        ) : <GptPrompt promptData={userIndividualData} />}

      </div>
    </>
  );
};
